//seo語系，自行修改(m2/m3)
const seoLang = 'm3';
const fetch = require('node-fetch');

//用環境變數判斷要使用哪個strapi domain
const getDeployEnv = () => {
  const DEPLOYENV = process?.env['DEPLOYENV'];
  if (!DEPLOYENV && (process.env.NODE_ENV !== "production")) {
    return 'LOCAL';
  } else {
    return DEPLOYENV;
  }
}

const getStrapiDomainByDeployEnv = (deployenv) => {
  //本地測試
  if (deployenv === 'LOCAL') {
    return 'https://cmsapistag.fun88.biz/';
  }else if (deployenv === 'STAG') {
    //STAG環境，會被擋，要從SL proxy進去
    return 'https://cmsapisl.fun88.biz/stag/';
  } else if (deployenv === 'SL') {
    return 'https://cmsapisl.fun88.biz/';
  } else { //LIVE
    return 'https://cache.huya66.cc/';
  }
}

//獲取SEO數據from API，自帶緩存
const getCachedStrapiSeoData = async (options) => {

  //options參數默認值
  options = Object.assign({
    name: 'notset??',     //緩存名
    queryType: 'notset',  //seo / seo-config 查詢類型
    pathname: '',         //頁面名，在這裡只用於log，只有 queryType=seo 才有用
  }, options);

  const isExportProcess = (process.env.NODE_ENV === "production");
  const cacheKey = `CACHE_${options.name}`;

  const deployEnv = getDeployEnv();
  const seoUrl = getStrapiDomainByDeployEnv(deployEnv) + `cms/${options.queryType}-${seoLang}`;
  const logHead = `===${options.name} [${deployEnv}] [${seoUrl}] [${options.pathname}] `;

  //export使用緩存
  if (isExportProcess) {
    if (global && global[cacheKey]) {
      console.error(logHead, 'use cache', JSON.stringify(global[cacheKey]));
      return global[cacheKey];
    }
  }

  console.error(logHead, 'before request');

  const jsonResult = await fetch(seoUrl)
    .then(response => {
      return response.json();
    })
    .then(jsonResponse => {
      return { success: true, data: jsonResponse};
    })
    .catch(e => {
      console.error(logHead, e, e?.message);
      return { success: false, error: e , errorMessage: e?.message};
    });

  if (jsonResult.success) {
    console.error(logHead,'done request', JSON.stringify(jsonResult));
    if(isExportProcess && global) {
      global[cacheKey] = JSON.parse(JSON.stringify(jsonResult));
    }
  } else {
    if (isExportProcess) {
      //連不上，讓export失敗
      if (process) {
        process.exit(500);
        return;
      }
    }
  }

  return jsonResult;
}


//獲取Strapi上面的SEO頁面配置，自帶緩存 (傳入的pathname只是用於log)
const getStrapiSEOSettings = async (pathname) => {
  const isExportProcess = (process.env.NODE_ENV === "production");
  const cacheKey = 'CACHE_getStrapiSEOSettings';

  const deployEnv = getDeployEnv();
  const seoUrl = getStrapiDomainByDeployEnv(deployEnv) + `cms/seo-${seoLang}`;
  const logHead = `===getStrapiSEOSettings [${deployEnv}] [${seoUrl}] [${pathname}] `;

  //export使用緩存
  if (isExportProcess) {
    if (global && global[cacheKey]) {
      console.error(logHead, 'use cache', JSON.stringify(global[cacheKey]));
      return global[cacheKey];
    }
  }

  console.error(logHead, 'before request');

  const jsonResult = await fetch(seoUrl)
    .then(response => {
      return response.json();
    })
    .then(jsonResponse => {
      return { success: true, data: jsonResponse};
    })
    .catch(e => {
      console.error(logHead, e, e?.message);
      return { success: false, error: e , errorMessage: e?.message};
    });

  if (jsonResult.success) {
    console.error(logHead,'done request', JSON.stringify(jsonResult));
    if(isExportProcess && global) {
      global[cacheKey] = JSON.parse(JSON.stringify(jsonResult));
    }
  } else {
    if (isExportProcess) {
      //連不上，讓export失敗
      if (process) {
        process.exit(500);
        return;
      }
    }
  }

  return jsonResult;
}

//獲取單page的SEO配置
const getStrapiSEOSettingForPage = async (pathname) => {
  const jsonResult = await getCachedStrapiSeoData({name: 'getStrapiSEOSettingForPage', queryType: 'seo' , pathname});
  //用pathname查對應數據
  if (jsonResult?.success && jsonResult?.data?.length > 0) {
    const target = jsonResult.data.find(d => d?.urlPath?.toLowerCase() ===  pathname?.toLowerCase() )
    if (target) {
      return { success: true, data: target}
    }
  }

  return { success: false, data: null}
}

//返回 seoData for getStaticProps
const getStaticPropsFromStrapiSEOSetting = async (pathname) => {
  const seoResult = await getStrapiSEOSettingForPage(pathname); //配置此頁的路徑
  console.log('===getStaticProps', pathname, JSON.stringify(seoResult));

  // Get GlobalHead and attached to seoData
  const globalSeoResult = await getStrapiSEOConfigs();
  let mergedSeoData = seoResult.success ? seoResult.data : {};
  
  if (globalSeoResult.success && globalSeoResult.data) {
    mergedSeoData = { ...globalSeoResult.data, ...mergedSeoData };
  }
  return { props: { seoData: mergedSeoData } };
}

//返回 seoConfigData for 生成robots.txt和sitemap.xml (在F1, web/mobile都會用到)
const getStrapiSEOConfigs = async () => {
  return getCachedStrapiSeoData({name: 'getStrapiSEOConfigs', queryType: 'seo-config' });
}

module.exports = {
  getStaticPropsFromStrapiSEOSetting,
  getStrapiSEOConfigs,
}
